module.exports = "/assets/src/components/PageHeader/bf-soin-maquillage.jpg";